import React from "react";
import * as API from "lib/apis";
import CryptoJS from "crypto-js";
import Top from "components/Top";
import Loader from "components/Loader";
import { ic_pw_bg } from "styles/img";

import { finishAlert, webviewFinish } from "lib/utils";

const queryString = require("query-string");

export default class OcbPw extends React.Component {
  state = {
    ocbPw: "",
    isLoading: false,
    encryptKey: "",
    name: "",
  };

  constructor(props) {
    super(props);
    this.queryObj = queryString.parse(props.location.search);
    this.webviewFinish = webviewFinish.bind(this);
    this.getEncryptPw = this.getEncryptPw.bind(this);
    this.closeWebview = this.closeWebview.bind(this);
    window.ocbPw = this;
  }

  closeWebview() {
    finishAlert("ocbPw.webviewFinish");
  }

  componentDidMount() {
    const serviceCode = this.queryObj["serviceCode"];
    if (serviceCode === "SYRUP") {
      window.wallet.setPageConfig(
        '{"pageType":"MEMBERSHIP", "backJS":"ocbPw.closeWebview"}'
      );
      window.wallet.setTitle('{"title":"비단 금투자 서비스"}');
    }
    const encryptKey = this.queryObj["authToken"];
    const name = this.queryObj["name"];
    this.setState((state) => ({
      ...state,
      encryptKey: encryptKey,
      name: name,
      serviceCode: serviceCode,
    }));
  }

  handleChangeOcbPoint = ({ target: { value } }) => {
    let ocbPw = value;
    if (ocbPw.length > 16) {
      ocbPw = value.substr(0, 16);
    }
    this.setState({ ocbPw: ocbPw });
  };

  handleClickOcbConfirm = () => {
    const ocbPw = this.getEncryptPw(this.state.ocbPw);
    this.setState({ isLoading: true });
    API.authOcb(ocbPw, ({ success, errorMessage, data }) => {
      if (success) {
        if (data.ocbPoint !== null && data.ocbPoint !== undefined) {
          this.props.history.push({
            pathname: "/main",
            search: `?name=${this.state.name}&serviceCode=SYRUP`,
          });
        }
      } else {
        alert(errorMessage);
        this.setState((state) => ({
          ...state,
          ocbPw: "",
          isLoading: false,
        }));
      }
    });
  };

  getEncryptPw = (password) => {
    const p = this.state.encryptKey;
    var iv = CryptoJS.lib.WordArray.create([0, 0, 0, 0]);
    const key = CryptoJS.enc.Utf8.parse(p);
    for (var i = key.words.length; i < 4; i++) {
      key.words[i] = 0;
    }
    key.sigBytes = 16;
    key.clamp();

    const encrypted = CryptoJS.AES.encrypt(password, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  };

  render() {
    const { isLoading, ocbPw } = this.state;
    return (
      <>
        {isLoading && <Loader />}
        <Top history={this.props.history} />
        <div className="wrap">
          <div className="content">
            <h2 className="img_box">
              <img src={ic_pw_bg} alt="아이콘 포인트 이미지" />
            </h2>
            <h4 className="h44">
              서비스를 사용하시기 위하여
              <br />
              OK캐쉬백 포인트 비밀번호가 필요합니다.
            </h4>
            <div className="tab_box2">
              <div id="container">
                <div id="tab1" className="tabcontent current">
                  <div className="tit_wrap">
                    <h4 className="mtit2">OK캐쉬백 온라인 비밀번호</h4>
                  </div>
                  <div className="input_box2">
                    <input
                      type="password"
                      className="input_box2"
                      placeholder="비밀번호"
                      value={ocbPw}
                      onChange={this.handleChangeOcbPoint}
                      maxLength="16"
                    />
                    {ocbPw.length > 0 && <span className="left">비밀번호</span>}
                  </div>
                </div>
              </div>
            </div>

            <div className="btn_area fix_bottom">
              <div className="bt_col1">
                <input
                  type="button"
                  value="확인"
                  className="blue"
                  disabled={ocbPw.length === 0 && true}
                  onClick={this.handleClickOcbConfirm}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
